"use client";

import { Config, Template } from "src/types";
import { mockConfig } from "../../constants/mockConfig";
import { useTheme } from "../../contexts/useTheme";
import { layoutComponentMap } from "../../SelectLayoutComponent";
import Skeleton from "react-loading-skeleton";
import { useMemo } from "react";

const HeaderSwitch: React.FC<{ serverconfig: Config }> = ({ serverconfig }) => {
  const { config } = useTheme();
  const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

  // Safely get navbar components map
  const pageComponents = layoutComponentMap["navbar"] ?? {};

  // Determine which template to use based on mode
  const templateKey = isDemoMode ? config?.template : serverconfig.template;

  // Memoize selected component to avoid recalculations on rerenders
  const SelectedComponent = useMemo(() => {
    return pageComponents[templateKey as Template] || pageComponents["design1"];
  }, [pageComponents, templateKey]);

  // Show skeleton while config template is loading (only in demo mode)
  if (isDemoMode && !templateKey) {
    return <Skeleton width="100vw" height={50} />;
  }

  // Use actual styling if available, fallback to mockConfig
  const styling = config?.styling ?? mockConfig.styling;

  return <SelectedComponent styling={styling} />;
};

export default HeaderSwitch;
